import { useState } from "react";

interface LookupOption {
  id: number;
  label: string;
}

const SearchableDropdown: React.FC<{
  value: string;
  placeholder: string;
  options: LookupOption[];
  onSelect: (v: LookupOption) => void;
}> = ({ value, placeholder, options, onSelect }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filtered = options.filter(o =>
    o.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="relative">
      {/* Input with dropdown icon */}
      <div className="relative">
        <input
          readOnly
          value={value}
          placeholder={placeholder}
          onClick={() => setOpen(true)}
          className="w-full px-3 py-1 pr-8 border border-gray-300 rounded text-xs bg-white cursor-pointer"
        />
        
        {/* Dropdown Icon */}
        <div 
          className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none"
          onClick={() => setOpen(!open)}
        >
          <svg
            className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${
              open ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>

      {/* Dropdown Menu */}
      {open && (
        <>
          {/* Backdrop to close dropdown when clicking outside */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => {
              setOpen(false);
              setSearch("");
            }}
          />
          
          <div className="absolute z-50 bg-white border rounded shadow-lg w-full mt-1">
            <input
              autoFocus
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search..."
              className="w-full px-2 py-1 text-xs border-b outline-none"
            />

            <div className="max-h-48 overflow-y-auto">
              {filtered.map(item => (
                <div
                  key={item.id}
                  onClick={() => {
                    onSelect(item);
                    setOpen(false);
                    setSearch("");
                  }}
                  className="px-3 py-1 text-xs hover:bg-blue-100 cursor-pointer"
                >
                  {item.label}
                </div>
              ))}
              {filtered.length === 0 && (
                <div className="px-3 py-2 text-xs text-gray-400">
                  No results
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SearchableDropdown;
